import { BaseEntityService } from '/@/modules/core/app/services/abstracts/BaseEntityService';
import { Route } from '/@/modules/core/app/constants/api.constants';
import { County } from '/@/modules/predefined/models/County';

export class CountyService extends BaseEntityService {
  getRoute() {
    return Route.PREDEFINED_COUNTIES;
  }

  getModel() {
    return County;
  }

  /**
   * @param {string} name
   * @param {number} jurisdictionId
   * @returns {?County}
   */
  async getCountyByNameAndJurisdiction(name, jurisdictionId) {
    const counties = await this.getEntities({ name, jurisdictionId });
    return counties?.[0];
  }
}

export default new CountyService();
